import { render } from "./HomeCircleBlue.vue?vue&type=template&id=b04e547c"
import script from "./HomeCircleBlue.vue?vue&type=script&lang=js"
export * from "./HomeCircleBlue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__